// ============= Imports =============
import { SignalRContextProps } from '@/contexts/SignalRContext';

// ============= Constants =============
const HUB_NAME = 'userRelayHub';

// ============= Types =============
export interface SendUserTypingStateUserSessionProps {
  invokeHub: SignalRContextProps['invokeHub'];
  workspaceId: string;
  userId: string;
  isTyping: boolean;
}

// ============= Main Function =============
/**
 * Sends user typing state via UserMessageRelayHub
 * @param invokeHub Function to invoke SignalR hub methods
 * @param workspaceId The workspace ID
 * @param userId The ID of the user
 * @param isTyping Whether the user is typing
 * @returns Promise with API response or error
 */
export const sendUserTypingStateUserSession = async ({
  invokeHub,
  workspaceId,
  userId,
  isTyping,
}: SendUserTypingStateUserSessionProps): Promise<any> => {
  try {
    console.log(
      `🔄 Sending typing state for user [${userId}] in workspace [${workspaceId}] via UserMessageRelayHub...`
    );

    if (!workspaceId) {
      throw new Error('workspaceId is required');
    }
    if (!userId) {
      throw new Error('userId is required');
    }

    const result = await invokeHub<any>(
      HUB_NAME,
      'SendUserTypingStateAsync',
      workspaceId,
      userId,
      isTyping
    );

    console.log(
      `✅ Typing state sent successfully for user [${userId}] in workspace [${workspaceId}]`
    );
    return result;
  } catch (error) {
    console.error(
      `🔴 Error sending typing state for user [${userId}] in workspace [${workspaceId}] via UserMessageRelayHub:`,
      error
    );
    throw error;
  }
};
